import { CCol, CLabel, CSelect } from "@coreui/react";
import { useEffect, useState } from "react";
import { apiCallResponse } from "src/_apiConfig/apiCall";

const DropDownDisctrict = (props) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    getDistrictList();
    // eslint-disable-next-line
  }, [props.isClear]);

  const getDistrictList = async () => {
    let url = `District_Master`;
    if (props.isOfficer === true) {
      url = `District_Master/getOfficers`;
    }
    await apiCallResponse(url).then((res) => {
      if (res.success) {
        if (props.isOfficer === true) {
          console.log("isOfficer", res.data);
          const sortedData = res.data.sort((a, b) =>
            a.districtName.localeCompare(b.districtName)
          );

          const uniqueDataMap = new Map();

          sortedData.forEach((item) => {
            const { districtName, districtId } = item;
            console.log("districtName", districtName, " | ", districtId);

            if (!uniqueDataMap.has(districtName)) {
              uniqueDataMap.set(districtName, {
                value: districtId,
                name: districtName,
              });
            }
          });

          const uniqueGroupedData = Array.from(uniqueDataMap.values());

          // const sortedGroupedData = Object.keys(groupedData)
          //   .sort((a, b) => a.localeCompare(b))
          //   .reduce((acc, key) => {
          //     acc[key] = groupedData[key];
          //     return acc;
          //   }, {});

          console.log("groupedData districtName:", uniqueGroupedData);
          setItems(uniqueGroupedData);
        } else {
          setItems(res.data);
        }
      }
    });
  };

  return (
    <CCol xl={props.xl || 3} sm={props.sm || 6}>
      <CLabel> District :</CLabel>
      <CSelect
        id="disctrictId"
        name={props.name}
        aria-label="Default select example"
        value={props.value}
        onChange={props.onChange}
      >
        <option value="">Select District Union</option>
        {props.isValueLabelSame === false
          ? items
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((item, key) => (
                <option key={key} value={item.value}>
                  {item.name}
                </option>
              ))
          : items
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((item, key) => (
                <option key={key} value={item.name}>
                  {item.name}
                </option>
              ))}
      </CSelect>
    </CCol>
  );
};

export default DropDownDisctrict;
